import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Preloader } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { Topbar } from '@/modules/core/components';
import { useBreadcrumbs } from '@/modules/core/hooks';
import { Deductibles } from '@/modules/deductibles';
import { useDependents } from '@/modules/deductibles/SpendTracker/hooks';
import { useGetEmployeeById } from '@/modules/employee/Employee/hooks';
import theme from '@/styles/theme';

const DeductiblesPage = () => {
  const { userId, employeeId, yearId } = useParams<{ userId: string, employeeId: string, yearId: string }>();  
  const { isLoading, data: employeeData } = useGetEmployeeById(employeeId);
  const employeeUser = useMemo(
    () => ({
      id: `${employeeData?.internalId || ''}`,
      fullName: `${employeeData?.firstName || ''} ${employeeData?.lastName || ''}`.trim(),
    }), [employeeData],
  );
  const users = useDependents({
    userId, isIndividual: true, employeeUser,
  });

  const user = useMemo(() => {
    if (users.length) {
      return users[0];
    }
    return null;
  }, [users]);

  useBreadcrumbs([{
    route: ROUTES.EMPLOYEES,
    title: 'Employees',
  },
  {
    route: ROUTES.EMPLOYEE_VIEW(employeeId),
    title: `${employeeUser?.fullName || ''}`,
  },
  {
    route: ROUTES.SPENDS_BY_ID(employeeId, userId, yearId),
    title: `Deductible ${user?.fullName || ''}`,
  }], [user, employeeUser, yearId]);

  if (isLoading) {
    return <Box width="100%" margin={{ vertical: 'xs' }}><Preloader testId="deductibles" /></Box>;
  }

  return (
    <Box width="100%" margin={{ bottom: 'xxxl' }} height="fit-content">
      <Topbar />
      <Box width={theme.defaultContentWidth} margin={{ horizontal: 'auto' }} pad={{ top: 'l' }}>
        <Deductibles userId={userId} employeeUser={employeeUser} healthPlanYearId={yearId} />
      </Box>
    </Box>

  );
};

export default DeductiblesPage;
